import type { IFormxRepository, ReorderInput } from '../repositories/IFormxRepository.js';

interface Deps { formxRepository: IFormxRepository; }

export function createReorderFormxFormsUseCase({ formxRepository }: Deps) {
  return async function reorderFormxForms(updates: ReorderInput): Promise<void> {
    return formxRepository.reorderForms(updates);
  };
}
